import React from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonTable = ({ recommendations }) => {
  const comparisonMetrics = [
    { key: 'investmentRequired', label: 'Investasi Diperlukan', icon: 'DollarSign' },
    { key: 'timeline', label: 'Timeline', icon: 'Clock' },
    { key: 'riskLevel', label: 'Tingkat Risiko', icon: 'AlertTriangle' },
    { key: 'confidenceScore', label: 'Confidence Score', icon: 'Target' },
    { key: 'implementationComplexity', label: 'Kompleksitas', icon: 'Settings' },
    { key: 'expectedROI', label: 'Expected ROI', icon: 'TrendingUp' }
  ];

  const getValueDisplay = (recommendation, key) => {
    const value = recommendation?.[key];
    
    if (key === 'confidenceScore') {
      return (
        <div className="flex items-center gap-2">
          <div className="w-20 h-2 bg-muted rounded-full overflow-hidden">
            <div 
              className="h-full bg-primary transition-all duration-500"
              style={{ width: `${value}%` }}
            />
          </div>
          <span className="text-sm font-semibold data-text">{value}%</span>
        </div>
      );
    }
    
    if (key === 'riskLevel') {
      const colors = {
        'Rendah': 'text-success bg-success/10',
        'Sedang': 'text-warning bg-warning/10',
        'Tinggi': 'text-destructive bg-destructive/10'
      };
      return (
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${colors?.[value] || 'text-muted-foreground bg-muted'}`}>
          {value}
        </span>
      );
    }
    
    return <span className="text-sm font-medium">{value}</span>;
  };

  return (
    <div className="card overflow-hidden">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="GitCompare" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold">Perbandingan Rekomendasi</h3>
          <p className="text-sm text-muted-foreground">Analisis komparatif antar opsi strategis</p>
        </div>
      </div>
      <div className="overflow-x-auto -mx-8 px-8">
        <table className="w-full min-w-[800px]">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-4 px-4 text-sm font-semibold text-muted-foreground">
                Metrik
              </th>
              {recommendations?.map((rec) => (
                <th key={rec?.id} className="text-center py-4 px-4">
                  <div className="flex flex-col items-center gap-2">
                    <div 
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ 
                        backgroundColor: rec?.variant === 'aggressive' ? 'var(--color-success)15' :
                                       rec?.variant === 'controlled' ? 'var(--color-primary)15' :
                                       rec?.variant === 'hold' ? 'var(--color-warning)15' :
                                       'var(--color-destructive)15'
                      }}
                    >
                      <Icon 
                        name={rec?.icon} 
                        size={20} 
                        color={
                          rec?.variant === 'aggressive' ? 'var(--color-success)' :
                          rec?.variant === 'controlled' ? 'var(--color-primary)' :
                          rec?.variant === 'hold' ? 'var(--color-warning)' :
                          'var(--color-destructive)'
                        }
                      />
                    </div>
                    <span className="text-sm font-semibold">{rec?.title}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {comparisonMetrics?.map((metric, index) => (
              <tr key={metric?.key} className={index !== comparisonMetrics?.length - 1 ? 'border-b border-border' : ''}>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-2">
                    <Icon name={metric?.icon} size={16} color="var(--color-muted-foreground)" />
                    <span className="text-sm font-medium">{metric?.label}</span>
                  </div>
                </td>
                {recommendations?.map((rec) => (
                  <td key={rec?.id} className="py-4 px-4 text-center">
                    {getValueDisplay(rec, metric?.key)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComparisonTable;